import React from 'react'
import Footer from '../components/Footer'
import ProductList from '../components/ProductCard'
const productPage = () => {
    return (
        <div>
            <ProductList/>
            <Footer/>
        </div>
    )
}

export default productPage
